/**
 * @file Confirmation dialog-related text
 */
import { __ } from 'bits/intl'

export const CONFIRM_DISCARD_CHANGES: { [key: string]: string } = {
  title: __('You have unsaved changes'),
  body: __('Are you sure you want to discard them and close this panel?'),
  confirmButtonText: __('Discard and close'),
  cancelButtonText: __('Keep working'),
}

export const SAVE_CHANGES_FAILED: { [key: string]: string } = {
  message: __("Sorry, we couldn't save your changes. Please refresh the page."),
  actionText: __('Refresh'),
  actionName: 'reloadPage',
}

export const NOT_AUTHORIZED_TO_ACCESS_PADLET: { [key: string]: string } = {
  message: __('You are not authorized to access this padlet anymore.'),
  actionText: __('Refresh'),
  actionName: 'reloadPage',
}

export const deleteWallConfirmationParams = (wallTitle: string): { [key: string]: string | boolean } => ({
  isCodeProtected: true,
  title: __('Delete "%{wallTitle}"?', { wallTitle }),
  body: __('This action cannot be undone.'),
  confirmButtonText: __('Delete'),
  cancelButtonText: __('Nevermind'),
})

export default {
  CONFIRM_DISCARD_CHANGES,
  SAVE_CHANGES_FAILED,
  NOT_AUTHORIZED_TO_ACCESS_PADLET,
  deleteWallConfirmationParams,
}
